<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/neYRlv/tc-custom/9780547526195.jpg?1701639299397" alt="This image is the cover for the book Sir Vidia's Shadow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sir Vidia's Shadow
      </h1>
      <p class="bookDescription body article font2">
        <b>The acclaimed writer shares an intimate portrait of his former mentor V.S. Naipaul in this memoir of their thirty-year friendship and sudden falling out.</b><br/><br/>Paul Theroux was a young aspiring writer when he met the legendary V.S. Naipaul in Uganda in 1966. There began a friendship that would span continents as both men ascended the ranks of literary stardom. Naipaul’s early encouragement of Theroux’s talent had a profound impact on him—yet the apprenticeship was not always easy.<br/><br/>This heartfelt and revealing account of Theroux's thirty-year friendship with Naipaul explores the unique effect each writer had on the other. Built around exotic landscapes, anecdotes that are revealing, humorous, and melancholy, and three decades of mutual history, this is a personal account of how one develops as a writer and how a friendship waxes and wanes between two men who have set themselves on the perilous journey of a writing life.<br/><br/><b>A <i>New York Times</i> Notable Book</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Theroux
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e92c9f5